import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import substackPosts from './Substack/posts/posts-list.json';
import mediumPosts from './Medium/posts/posts-list.json';
import baeldungPosts from './Baeldung/posts/posts-list.json';
import './Writing.css';

const Writing = () => {
  const featuredSubstack = substackPosts.slice(0, 3);
  const featuredMedium = mediumPosts.slice(0, 3);
  const featuredBaeldung = baeldungPosts.slice(0, 3);

  return (
    <>
      <Helmet>
        <title>Writing - Victor Barbarosh</title>
        <meta name="description" content="Articles and publications" />
      </Helmet>
      
      <div className="platform-page">
        <Link to="/" className="home-link top">
          <img src="/portfolio/assets/images/victor-barbarosh-profile.png" alt="Home" className="home-icon" />
          Home
        </Link>

        <header className="platform-header">
          <h1>Writing</h1>
          <p className="platform-description">Articles and publications across platforms</p>
        </header>

        <section className="writing-section">
          <div className="writing-platform-header">
            <img src="/portfolio/assets/images/substack-logo.svg" alt="Substack" className="writing-platform-logo" />
            <div>
              <h2>The Cybersecurity Newsletter</h2>
              <p>Your Monday cybersec intelligence briefing</p>
            </div>
          </div>
          <div className="writing-list">
            {featuredSubstack.map(post => (
              <Link key={post.id} to={`/substack/${post.id}`} className="writing-item">
                <span className="writing-title">{post.title}</span>
                <span className="writing-date">{new Date(post.datePublished).toLocaleDateString()}</span>
              </Link>
            ))}
          </div>
          <Link to="/substack" className="view-all-link">View all Substack posts →</Link>
        </section>

        <section className="writing-section">
          <div className="writing-platform-header">
            <img src="/portfolio/assets/images/medium-logo.svg" alt="Medium" className="writing-platform-logo" />
            <div>
              <h2>Medium</h2>
              <p>Tech insights & creative writings</p>
            </div>
          </div>
          <div className="writing-list">
            {featuredMedium.map(post => (
              <Link key={post.id} to={`/medium/${post.id}`} className="writing-item">
                <span className="writing-title">{post.title}</span>
                <span className="writing-date">{new Date(post.datePublished).toLocaleDateString()}</span>
              </Link>
            ))}
          </div>
          <Link to="/medium" className="view-all-link">View all Medium articles →</Link>
        </section>

        <section className="writing-section">
          <div className="writing-platform-header">
            <img src="/portfolio/assets/images/spring-logo.png" alt="Baeldung" className="writing-platform-logo" />
            <div>
              <h2>Baeldung</h2>
              <p>Java & Spring tutorials</p>
            </div>
          </div>
          <div className="writing-list">
            {featuredBaeldung.map(post => (
              <Link key={post.id} to={`/baeldung/${post.id}`} className="writing-item">
                <span className="writing-title">{post.title}</span>
                <span className="writing-date">{new Date(post.datePublished).toLocaleDateString()}</span>
              </Link>
            ))}
          </div>
          <Link to="/baeldung" className="view-all-link">View all Baeldung articles →</Link>
        </section>

        <Link to="/" className="home-link bottom">
          <img src="/portfolio/assets/images/victor-barbarosh-profile.png" alt="Home" className="home-icon" />
          Home
        </Link>
      </div>
    </>
  );
};

export default Writing;
